import React, { useState, useRef, useEffect } from "react";
import "../styles/BeginnerPanelSizing.css";
import "../styles/SolarSizingCalculator.css";
import { toast } from "react-toastify";
import Modal from "react-modal";

Modal.setAppElement("#root");

const loadPaystackScript = () => {
  return new Promise((resolve, reject) => {
    if (document.getElementById("paystack-script")) return resolve();
    const script = document.createElement("script");
    script.id = "paystack-script";
    script.src = "https://js.paystack.co/v1/inline.js";
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

const addDays = (date, days) => {
  const d = new Date(date);
  d.setDate(d.getDate() + days);
  return d;
};

const BeginnerPanelSizing = () => {
  const [step, setStep] = useState(1);
  const [location, setLocation] = useState("");
  const [usageType, setUsageType] = useState("");
  const [appliances, setAppliances] = useState([]);
  const [customItem, setCustomItem] = useState({ name: "", watt: "", hours: "" });
  const [daysOfAutonomy, setDaysOfAutonomy] = useState("");
  const [recommendation, setRecommendation] = useState(null);

  // ===== Subscription State =====
const trialLimit = 3;

const [calcCount, setCalcCount] = useState(
  () => Number(localStorage.getItem("calcCount") || 0)
);

const [isSubscribed, setIsSubscribed] = useState(
  localStorage.getItem("isSubscribed") === "true"
);

const [subscriptionExpiry, setSubscriptionExpiry] = useState(
  localStorage.getItem("subscriptionExpiry") || ""
);

const [email, setEmail] = useState(
  localStorage.getItem("userEmail") || ""
);

const [showModal, setShowModal] = useState(false);
const [showEmailModal, setShowEmailModal] = useState(false);
const [tempEmail, setTempEmail] = useState("");
const [pendingPlan, setPendingPlan] = useState(null);
const [subLoading, setSubLoading] = useState(false);

const plans = [
  { label: "1 Month", days: 30, amountNGN: 1000 },
  { label: "3 Months", days: 90, amountNGN: 2500 },
  { label: "6 Months", days: 180, amountNGN: 5500 },
  { label: "1 Year", days: 365, amountNGN: 10000 },
];


useEffect(() => {
  loadPaystackScript().catch(() => {});
}, []);

useEffect(() => {
  if (!subscriptionExpiry) return;

  const now = new Date();
  const exp = new Date(subscriptionExpiry);

  if (now > exp) {
    setIsSubscribed(false);
    localStorage.setItem("isSubscribed", "false");
  }
}, [subscriptionExpiry]);




  const carouselRef = useRef(null);

  const commonAppliances = [
    { name: "Bulb", watt: 10 },
    { name: "Fan", watt: 60 },
    { name: "TV", watt: 80 },
    { name: "Laptop", watt: 60 },
    { name: "Phone Charger", watt: 10 },
    { name: "Refrigerator (Small 100L)", watt: 100 },
    { name: "Refrigerator (Medium 200L)", watt: 200 },
    { name: "Refrigerator (Large 300L)", watt: 300 },
    { name: "AC (0.5HP)", watt: 400 },
    { name: "AC (1HP)", watt: 900 },
    { name: "AC (1.5HP)", watt: 1350 },
    { name: "AC (2HP)", watt: 1800 },
    { name: "AC (3HP)", watt: 2700 },
    { name: "Washing Machine", watt: 500 },
    { name: "Microwave", watt: 1000 },
    { name: "Water Pump", watt: 750 },
  ];

  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  const toggleAppliance = (item) => {
    if (appliances.find((a) => a.name === item.name)) {
      setAppliances(appliances.filter((a) => a.name !== item.name));
    } else {
      setAppliances([...appliances, { ...item, hours: "", count: "" }]);
    }
  };

  const updateApplianceHours = (index, hours) => {
    const updated = [...appliances];
    updated[index].hours = hours;
    setAppliances(updated);
  };

  const updateApplianceCount = (index, count) => {
    const updated = [...appliances];
    updated[index].count = count;
    setAppliances(updated);
  };

  const addCustomAppliance = () => {
    if (customItem.name && customItem.watt) {
      setAppliances([...appliances, { ...customItem, hours: "", count: "" }]);
      setCustomItem({ name: "", watt: "", hours: "" });
    }
  };


  const activateSubscription = (days) => {
  let baseDate = new Date();

  if (subscriptionExpiry) {
    const existing = new Date(subscriptionExpiry);
    if (existing > baseDate) baseDate = existing;
  }

  const newExpiry = addDays(baseDate, days);

  localStorage.setItem("isSubscribed", "true");
  localStorage.setItem("subscriptionExpiry", newExpiry.toISOString());
  localStorage.setItem("calcCount", "0");

  setIsSubscribed(true);
  setSubscriptionExpiry(newExpiry.toISOString());
  setCalcCount(0);

  toast.success(`Subscription active till ${newExpiry.toDateString()}`);
};

const initiatePayment = (plan) => {
  if (!window.PaystackPop) {
    toast.error("Payment system not ready");
    return;
  }

  if (!email) {
    setPendingPlan(plan);
    setShowEmailModal(true);
    return;
  }

  setSubLoading(true);

  const handler = window.PaystackPop.setup({
    key: "pk_live_7264851bb6628e9752b2aafb66c35e9064d1efe7", // 🔴 REPLACE
    email,
    amount: plan.amountNGN * 100,
    currency: "NGN",
    ref: `BEGINNER-${Date.now()}`,
    callback: () => {
      activateSubscription(plan.days);
      setSubLoading(false);
      setShowModal(false);
    },
    onClose: () => setSubLoading(false),
  });

  handler.openIframe();
};


  const calculateRecommendation = () => {

  // STOP USER IF NOT SUBSCRIBED AND TRIALS ARE USED
  if (!isSubscribed) {
    const count = Number(localStorage.getItem("calcCount") || 0);

    if (count >= 3) {
      toast.info("Free limit reached. Subscribe to continue.");
      setShowModal(true);
      return;
    }

    localStorage.setItem("calcCount", String(count + 1));
    setCalcCount(count + 1);
  }



    // 1) Total daily energy consumption (Wh/day)
    const totalWhPerDay = appliances.reduce(
      (sum, item) => sum + item.watt * (item.hours || 0) * (item.count || 0),
      0
    );

    // 1a) Instantaneous total load (W)
    const totalLoadPowerW = appliances.reduce(
      (sum, item) => sum + item.watt * (item.count || 0),
      0
    );

    // Constants
    const systemLossFactor = 1.2;
    const inverterEfficiency = 0.9;
    const tempDerateFactor = 0.9;
    const DoD_lithium = 0.9;
    const DoD_lead = 0.7;
    const performanceRatio = 0.65;
    const peakSunHours = 4.5;

    // Adjusted total Wh
    const totalWhWithLosses = totalWhPerDay * systemLossFactor;
    const dailyEnergyNeededFromPanels = totalWhWithLosses / inverterEfficiency;

    const autonomyDays = Math.max(1, Number(daysOfAutonomy) || 1);
    const energyForAutonomy = dailyEnergyNeededFromPanels * autonomyDays;
    const energyAfterTemp = energyForAutonomy / tempDerateFactor;

    // Battery energy requirements
    const batteryWhNeeded_lead = energyAfterTemp / DoD_lead;
    const batteryWhNeeded_lithium = energyAfterTemp / DoD_lithium;

    // Auto-select system voltage (capped at 48V for residential systems)
    const totalWhBaseline = batteryWhNeeded_lead;
    const batteryVoltage =
      totalWhBaseline < 2000 ? 12 : totalWhBaseline < 5000 ? 24 : 48;

    const requiredAh_lead = Math.ceil(batteryWhNeeded_lead / batteryVoltage);
    const leadAcidUnitAh = 220;
    const leadAcidNominal = 12;
    const seriesBatteries = Math.ceil(batteryVoltage / leadAcidNominal);
    const parallelBatteries = Math.ceil(requiredAh_lead / leadAcidUnitAh);
    const leadAcidCount = Math.max(seriesBatteries * parallelBatteries, 1);

    const lithiumKwh = (batteryWhNeeded_lithium / 1000).toFixed(2);
    const requiredAh_lithium = Math.ceil(batteryWhNeeded_lithium / batteryVoltage);

    // Inverter sizing
    // Inverter sizing (with safety margin for losses and expansion)
    const powerFactor = 0.8; // typical for mixed loads
    const safetyMargin = 1.25; // 25% buffer to account for losses + future expansion
    const inverterContinuousW = Math.max(
      1000,
      Math.ceil((totalLoadPowerW / powerFactor) * safetyMargin)
    );

    const inverterRequiredKW = +(inverterContinuousW / 1000).toFixed(2);
    const inverterKva = Math.max(1, Math.ceil(inverterContinuousW / 1000));
    const surgeFactorMin = 2;
    const surgeFactorMax = 3;
    const recommendedSurgeWMin = inverterContinuousW * surgeFactorMin;
    const recommendedSurgeWMax = inverterContinuousW * surgeFactorMax;

    // Panel options - expanded list as requested
    const panelSizes = [200, 270, 300, 350, 400, 450, 500, 550, 600];
    const panelOptions = panelSizes.map((size) => {
      // Suggested quantity to meet daily energy (rounded up)
      const suggestedQty = Math.ceil(
        dailyEnergyNeededFromPanels / (size * peakSunHours * performanceRatio)
      );

      // 0.5C calculation (based on lithium bank Ah at chosen system voltage)
      const lithiumAh =
        batteryWhNeeded_lithium > 0
          ? Math.ceil(batteryWhNeeded_lithium / batteryVoltage)
          : 0;
      const requiredChargePowerForHalfC_W = Math.ceil(0.5 * lithiumAh * batteryVoltage);
      const panelEffectivePowerW = size * performanceRatio; // instantaneous effective power after PR
      const panelsForHalfC =
        panelEffectivePowerW > 0
          ? Math.ceil(requiredChargePowerForHalfC_W / panelEffectivePowerW)
          : 0;

      // Efficiency label mapping (sensible buckets)
      const efficiency =
        size <= 250 ? "Basic" : size <= 350 ? "Good" : size <= 450 ? "Better" : "Best";

      return {
        size,
        count: suggestedQty,
        panelsAtHalfC: panelsForHalfC,
        efficiency,
      };
    });

    // Determine best panel size like before (heuristic)
    const bestPanelSize =
      dailyEnergyNeededFromPanels < 2500
        ? 200
        : dailyEnergyNeededFromPanels < 5000
        ? 300
        : dailyEnergyNeededFromPanels < 8000
        ? 400
        : 500;

    // If bestPanelSize not in panelOptions (e.g., 500 exists) find closest
    const recommended =
      panelOptions.find((p) => p.size === bestPanelSize) || panelOptions[panelOptions.length - 1];

    setRecommendation({
      totalWhPerDay,
      totalWhWithLosses,
      dailyEnergyNeededFromPanels,
      autonomyDays,
      totalLoadPowerW,
      inverterContinuousW,
      inverterRequiredKW,
      inverterKva,
      recommendedSurgeWMin,
      recommendedSurgeWMax,
      panelOptions,
      bestPanelSize,
      recommended,
      leadAcidCount,
      leadAcidUnitAh,
      lithiumKwh,
      requiredAh_lead,
      requiredAh_lithium,
      batteryVoltage,
      batteryWhNeeded_lead,
      batteryWhNeeded_lithium,
    });

    nextStep();



  };

  return (
    <div className="beginner-sizing-page">
      <section className="hero-section">
        <section className="carousel-container">
          <div className="carousel-wrapper" ref={carouselRef}>
            <div className="carousel-cardpanel">
              <img src="/images/panelicon.png" alt="" className="card-iconpanel" />
              <div className="card-contentpanel">
                <h3>Courses</h3>
                <p>Learn valuable skills and gain expertise with top-rated courses.</p>
                <a href="/solar-resources" className="card-linkpanel">
                  Explore now →
                </a>
              </div>
            </div>
            <div className="carousel-cardpanel">
              <img src="/images/panelicon.png" alt="" className="card-iconpanel" />
              <div className="card-contentpanel">
                <h3>Consultation</h3>
                <p>Get personalized help and advice from our experts.</p>
                <a href="https://wa.me/2348131299300" className="card-linkpanel">
                  Book now →
                </a>
              </div>
            </div>
            <div className="carousel-cardpanel">
              <img src="/images/panelicon.png" alt="" className="card-iconpanel" />
              <div className="card-contentpanel">
                <h3>Installers</h3>
                <p>Find trusted installers in your area for any project size.</p>
                <a href="https://wa.me/2348131299300" className="card-linkpanel">
                  Find now →
                </a>
              </div>
            </div>
          </div>
        </section>
      </section>

      <img src="/images/3.png" alt="" className="card-iconpanelservicecenters" />

      <div className="containermain">
        <div className="card">
          <div className="panel-sizing-containertwo">
            <h2 className="panel-titlepanel">🌞 Beginner Solar Sizing</h2>
            <p className="panel-subtitlepanel">
              Let's figure out your solar needs in a few easy steps!
            </p>
          </div>
          <p className="step">Step {step} of 5</p>

          {/* Step 1 */}
          {step === 1 && (
            <div className="step-contentone">
              <h2>🏠 Where will you use your solar system?</h2>
              <select value={location} onChange={(e) => setLocation(e.target.value)}>
                <option value="">-- Select Location --</option>
                <option value="home">Home</option>
                <option value="office">Office</option>
                <option value="shop">Shop</option>
                <option value="farm">Farm</option>
              </select>
              <button disabled={!location} onClick={nextStep}>
                Next
              </button>
            </div>
          )}

          {/* Step 2 */}
          {step === 2 && (
            <div className="step-contenttwo">
              <h2>💡 How do you usually use energy?</h2>
              <select value={usageType} onChange={(e) => setUsageType(e.target.value)}>
                <option value="">-- Choose usage type --</option>
                <option value="light">Light (few bulbs, fan, phone)</option>
                <option value="medium">Medium (TV, fridge, fans)</option>
                <option value="heavy">Heavy (AC, freezer, washer)</option>
              </select>
              <div className="button-group">
                <button onClick={prevStep} className="back-btn">
                  Back
                </button>
                <button disabled={!usageType} onClick={nextStep}>
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Step 3 */}
          {step === 3 && (
            <div className="step-contentthree">
              <h2>⚙️ Select your appliances</h2>
              <p>Pick the appliances you use daily. You can also add custom ones below.</p>
              <div className="appliance-grid">
                {commonAppliances.map((item, i) => (
                  <label
                    key={i}
                    className={`appliance-item ${
                      appliances.find((a) => a.name === item.name) ? "selected" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={!!appliances.find((a) => a.name === item.name)}
                      onChange={() => toggleAppliance(item)}
                    />
                    {item.name} ({item.watt}W)
                  </label>
                ))}
              </div>

              <div className="custom-appliance">
                <input
                  type="text"
                  placeholder="Appliance name"
                  value={customItem.name}
                  onChange={(e) => setCustomItem({ ...customItem, name: e.target.value })}
                />
                <input
                  type="number"
                  placeholder="wattage"
                  value={customItem.watt}
                  onChange={(e) =>
                    setCustomItem({ ...customItem, watt: Number(e.target.value) })
                  }
                />
                <input
                  type="number"
                  placeholder="hours/day"
                  value={customItem.hours || ""}
                  onChange={(e) =>
                    setCustomItem({ ...customItem, hours: Number(e.target.value) })
                  }
                />
                <button onClick={addCustomAppliance}>Add</button>
              </div>

              <div className="button-group">
                <button onClick={prevStep} className="back-btn">
                  Back
                </button>
                <button disabled={appliances.length === 0} onClick={nextStep}>
                  Next
                </button>
              </div>
            </div>
          )}

          {/* Step 4 */}
          {step === 4 && (
            <div className="step-content">
              <h4>🕒 Set usage hours & backup days</h4>
              {appliances.map((item, index) => (
                <div key={index} className="hours-input">
                  <label>
                    {item.name} ({item.watt}W)
                  </label>
                  <div className="usage-inputs">
                    <input
                      type="number"
                      min="1"
                      placeholder={`Enter number of ${item.name}(s)`}
                      value={item.count || ""}
                      onChange={(e) => updateApplianceCount(index, Number(e.target.value))}
                    />
                    <input
                      type="number"
                      min="0"
                      placeholder={`Enter hours used per day for ${item.name}`}
                      value={item.hours || ""}
                      onChange={(e) => updateApplianceHours(index, Number(e.target.value))}
                    />
                  </div>
                </div>
              ))}

              <div className="autonomy">
                <label>Backup days (no sunlight)</label>
                <input
                  type="number"
                  min="1"
                  placeholder="Enter number of days"
                  value={daysOfAutonomy || ""}
                  onChange={(e) => setDaysOfAutonomy(Number(e.target.value))}
                />
              </div>

              <div className="button-group">
                <button onClick={prevStep} className="back-btn">
                  Back
                </button>
                <button onClick={calculateRecommendation}>Calculate</button>
              </div>
            </div>
          )}

          {/* Step 5 */}
          {step === 5 && recommendation && (
            <div className="step-content">
              <h2>📊 Your Personalized Solar Suggestion</h2>
              <p>
                Based on your usage, your total energy need is{" "}
                <strong>{recommendation.totalWhPerDay.toLocaleString()} Wh/day</strong>. For{" "}
                <strong>{recommendation.autonomyDays}</strong> day(s) of backup, your total storage
                requirement (before chemistry DoD) is about{" "}
                <strong>
                  {Math.round(recommendation.dailyEnergyNeededFromPanels).toLocaleString()} Wh
                </strong>{" "}
                per day (includes buffers).
              </p>

              <h3>🔋 Battery Recommendation</h3>
              <p>
                <strong>Lead-acid (tubular) battery bank:</strong> You need approximately{" "}
                <strong>
                  {recommendation.leadAcidCount} of {recommendation.leadAcidUnitAh}Ah 12V
                </strong>{" "}
                batteries configured to a <strong>{recommendation.batteryVoltage}V</strong> system
                (≈ <strong>{recommendation.requiredAh_lead}</strong> Ah at system voltage).
              </p>

              <p>
                <strong>Lithium equivalent:</strong> ~ <strong>{recommendation.lithiumKwh} kWh</strong>{" "}
                (≈ <strong>{recommendation.requiredAh_lithium}</strong> Ah at{" "}
                <strong>{recommendation.batteryVoltage}V</strong>).
              </p>

              <h3>⚙️ Inverter Recommendation</h3>
              <p>
                Your instantaneous load is <strong>{recommendation.totalLoadPowerW} W</strong>. Using
                Total Power ÷ 0.8, your inverter size is{" "}
                <strong>{recommendation.inverterRequiredKW} kW</strong> (~{" "}
                <strong>{recommendation.inverterKva} kVA</strong>).
              </p>
              <p>
                Surge loads (pumps, ACs, fridges) require 2×–3× for 2–5 seconds. Recommended surge:
                <strong>
                  {" "}
                  {Math.round(recommendation.recommendedSurgeWMin).toLocaleString()} –{" "}
                  {Math.round(recommendation.recommendedSurgeWMax).toLocaleString()} W
                </strong>
                .
              </p>

              <h3>☀️ Solar Panel Options</h3>
              <p>
                Panels should produce ~{" "}
                <strong>
                  {Math.round(recommendation.dailyEnergyNeededFromPanels).toLocaleString()}
                </strong>{" "}
                Wh/day (includes 20% losses).
              </p>

              <table className="panel-table">
                <thead>
                  <tr>
                    <th>Panel Rating</th>
                    <th>Suggested Quantity Options</th>
                    <th>Panels @ 0.5C Charge</th>
                    <th>Efficiency</th>
                  </tr>
                </thead>
                <tbody>
                  {recommendation.panelOptions.map((p, i) => (
                    <tr key={i}>
                      <td>{p.size} W</td>
                      <td>
                        {p.count} of {p.size}W panels
                      </td>
                      <td>
                        {p.panelsAtHalfC} panels of {p.size}W
                      </td>
                      <td>{p.efficiency}</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="summary-note">
                <p>
                  ✅ System: <strong>{recommendation.inverterRequiredKW} kW</strong> (~
                  <strong> {recommendation.inverterKva} kVA</strong>) inverter,{" "}
                  <strong>
                    {recommendation.leadAcidCount} of {recommendation.leadAcidUnitAh}Ah 12V
                  </strong>{" "}
                  (or ~<strong>{recommendation.lithiumKwh} kWh</strong> lithium), and{" "}
                  <strong>
                    {recommendation.recommended.count} of {recommendation.recommended.size}W panels
                  </strong>
                  .
                </p>

                <p>
                  ⚡ To safely charge lithium at 0.5C, you'll need roughly{" "}
                  <strong>
                    {
                      recommendation.panelOptions.find(
                        (x) => x.size === recommendation.recommended.size
                      )?.panelsAtHalfC
                    }
                  </strong>{" "}
                  panels of <strong>{recommendation.recommended.size}W</strong>.
                </p>
                <p>This setup ensures stable power, fast charging, and enough backup.</p>
              </div>

              <p className="tip">
                🌞 Tip: Plan about 20% extra capacity for cloudy weather and expansion.
              </p>

              <button onClick={() => window.location.reload()}>Start Over</button>
            </div>
          )}
        </div>
      </div>

      

<div className="subscription-card">
  <h3>Subscription Status</h3>

  {isSubscribed && subscriptionExpiry ? (
    <>
      <p>Status: <strong>Active ✅</strong></p>
      <p>
        Plan: <strong>
          {plans.find(
            (plan) =>
              new Date(subscriptionExpiry) <= addDays(new Date(), plan.days)
          )?.label || "Custom"}
        </strong>
      </p>
      <p>
        Expiry: <strong>{new Date(subscriptionExpiry).toDateString()}</strong></p>
      <p>
        Remaining: <strong>
          {Math.max(
            Math.ceil(
              (new Date(subscriptionExpiry) - new Date()) /
                (1000 * 60 * 60 * 24)
            ),
            0
          )}{" "}
          day{Math.max(
            Math.ceil(
              (new Date(subscriptionExpiry) - new Date()) /
                (1000 * 60 * 60 * 24)
            ),
            0
          ) !== 1
            ? "s"
            : ""}
        </strong>
      </p>
    </>
  ) : (
    <>
      <p>Status: <strong>Free / Trial ⚡</strong></p>
      <p>
        Free calculations used: {calcCount}/{trialLimit}
      </p>
    </>
  )}

  <button
    onClick={() => setShowModal(true)}
    disabled={subLoading}
    className="subscribe-btn small-btn"
  >
    {subLoading
      ? "Loading..."
      : isSubscribed
      ? "Extend / Upgrade"
      : "Subscribe to Unlock"}
  </button>

  <style jsx>{`
    .subscription-card {
      border: 1px solid #ddd;
      padding: 1rem;
      border-radius: 8px;
      max-width: 350px;
      margin: 1rem auto;
      box-shadow: 0 2px 6px rgba(0,0,0,0.1);
      font-size: 0.9rem;
      background: #fff;
    }

    .subscription-card h3 {
      margin-bottom: 0.5rem;
      font-size: 1.1rem;
      text-align: center;
    }

    .subscription-card p {
      margin: 0.25rem 0;
    }

    .subscribe-btn {
      width: 100%;
      padding: 0.6rem 1rem;
      margin-top: 0.8rem;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 0.9rem;
      transition: background 0.2s;
    }

    .subscribe-btn:hover {
      background-color: #0056b3;
    }

    .subscribe-btn.small-btn {
      padding: 0.4rem 0.8rem;
      font-size: 0.8rem;
    }

    @media (max-width: 480px) {
      .subscription-card {
        padding: 0.8rem;
        font-size: 0.85rem;
      }

      .subscribe-btn {
        font-size: 0.8rem;
        padding: 0.5rem 0.8rem;
      }
    }
  `}</style>
</div>




      <>
  {/* ================= Choose Plan Modal ================= */}
  <Modal
    isOpen={showModal}
    onRequestClose={() => setShowModal(false)}
    contentLabel="Choose a Plan"
    className="custom-modal"
    overlayClassName="custom-overlay"
    ariaHideApp={false}
  >
    <h2 className="modal-title">Choose a Plan</h2>

    {plans.map((plan, idx) => (
      <button
        key={idx}
        onClick={() => {
          setPendingPlan(plan);
          setShowModal(false);

          if (!email) {
            setShowEmailModal(true);
          } else {
            initiatePayment(plan);
          }
        }}
        className="plan-button"
      >
        {plan.label} — ₦{plan.amountNGN.toLocaleString()}
      </button>
    ))}

    <button
      onClick={() => setShowModal(false)}
      className="cancel-button"
    >
      Cancel
    </button>
  </Modal>

  {/* ================= Email Modal ================= */}
  <Modal
    isOpen={showEmailModal}
    onRequestClose={() => setShowEmailModal(false)}
    contentLabel="Enter Email"
    className="custom-modal"
    overlayClassName="custom-overlay"
    ariaHideApp={false}
  >
    <h2 className="modal-title">Enter Your Email</h2>

    <input
      type="email"
      placeholder="Email for receipt & reminders"
      value={tempEmail}
      onChange={(e) => setTempEmail(e.target.value)}
      className="email-input"
    />

    <div className="modal-actions">
      <button
        onClick={() => setShowEmailModal(false)}
        className="cancel-button"
      >
        Cancel
      </button>

      <button
        onClick={() => {
          if (!tempEmail) return;

          setEmail(tempEmail);
          localStorage.setItem("userEmail", tempEmail);
          setShowEmailModal(false);

          if (pendingPlan) {
            initiatePayment(pendingPlan);
            setPendingPlan(null);
          }
        }}
        className="calc-btn2"
      >
        Submit
      </button>
    </div>
  </Modal>
</>


    </div>
  );
};

export default BeginnerPanelSizing;
